import { render } from "./TripReservationList.vue?vue&type=template&id=6585f093"
import script from "./TripReservationList.vue?vue&type=script&lang=js"
export * from "./TripReservationList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__